import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {convertPipeToBrTag, convertKataToRome} from "../../utils";
import {WINDOW, NAVIGATOR, DOCUMENT, IS_MOBILE} from '../../constants/environment'
import './styles.css';
import Slider from "../../components/slider";
import Cta from "../cta";

import EstimateIconDark from './icon_estimate_dark.png';
import EstimateIconLight from './icon_estimate_light.png';

/**
 *  EstimationHistory
 */
class EstimationHistory extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    navigationTitle: PropTypes.string,
    navigationIcon: PropTypes.string,
    unsavedItemTabName: PropTypes.string,
    savedItemTabName: PropTypes.string,
    priceTitle: PropTypes.string,
    bodyColorTitle: PropTypes.string,
    seatColorTitle: PropTypes.string,
    makerOptionTitle: PropTypes.string,
    pcRecommendText: PropTypes.string,
    mbRecommendText: PropTypes.string,
    modelName: PropTypes.string,
    carId: PropTypes.string,
    carTypeCode: PropTypes.string,
    gradeId: PropTypes.string,
    estimateParam: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    navigationTitle: null,
    navigationIcon: null,
    unsavedItemTabName: null,
    savedItemTabName: null,
    priceTitle: null,
    bodyColorTitle: null,
    seatColorTitle: null,
    makerOptionTitle: null,
    pcRecommendText: null,
    mbRecommendText: null,
    modelName: null,
    carId: null,
    carTypeCode: null,
    gradeId: null,
    estimateParam: null
  };

  constructor(props) {
    super();
    this.props = props;

    this.state = {
      estType: '',
      unsavedIndex: 0,
      savedIndex: 0,
      carInfo: [],
      estExists: false,
    };

    this.tmp = {
      estType: '',
      unsavedIndex: 0,
      savedIndex: 0,
      carInfo: [],
    };
  }

  componentDidMount() {

    // WINDOW.MZD_CARINFO_SETTINGS = new Array(
    //   {ModelName: "atenza", CarId: "atenza-sedan", CarTypeCode: "GJ7"},
    //   {ModelName: "atenza", CarId: "atenza-wagon", CarTypeCode: "GJ8"},
    //   {ModelName: "axela", CarId: "axela-hybrid", CarTypeCode: "BY3"},
    //   {ModelName: "axela", CarId: "axela-sport", CarTypeCode: "BM5"},
    //   {ModelName: "axela", CarId: "axela-sedan", CarTypeCode: "BM6"},
    //   {ModelName: "demio", CarId: "demio", CarTypeCode: "DE8"},
    //   {ModelName: "cx-3", CarId: "cx-3", CarTypeCode: "DK4"},
    //   {ModelName: "cx-5", CarId: "cx-5", CarTypeCode: "KF4"},
    //   {ModelName: "cx-8", CarId: "cx-8", CarTypeCode: "GK2"},
    //   {ModelName: "roadster", CarId: "roadster", CarTypeCode: "RS2"},
    //   {ModelName: "roadsterrf", CarId: "roadsterrf", CarTypeCode: "RF2"},
    //   {ModelName: "flair", CarId: "flair", CarTypeCode: "MJ6"},
    //   {ModelName: "flair-wagon", CarId: "flair-wagon", CarTypeCode: "MM6"},
    //   {ModelName: "flair-crossover", CarId: "flair-crossover", CarTypeCode: "ZK4"},
    //   {ModelName: "carol", CarId: "carol", CarTypeCode: "HB1"},
    //   {ModelName: "scrum-wagon", CarId: "scrum-wagon", CarTypeCode: "DG1"},
    //   {}
    // );

    if(WINDOW && WINDOW.MZD_CARINFO_SETTINGS && Array.isArray(WINDOW.MZD_CARINFO_SETTINGS) && WINDOW.MZD_CARINFO_SETTINGS.length > 0){
      this.tmp.carInfo = WINDOW.MZD_CARINFO_SETTINGS;
      this.setState({
        carInfo: WINDOW.MZD_CARINFO_SETTINGS
      });
    }

    this.tmp.estType = this.existEst('unsaved') ? 'unsaved' : (this.existEst('saved') ? 'saved' : '')
    this.setState({
      estType: this.existEst('unsaved') ? 'unsaved' : (this.existEst('saved') ? 'saved' : '')
    });

    this.setState({
      estExists: (this.existEst('unsaved') || this.existEst('saved')) ? true : false
    });

    // for debug
    // if(new URLSearchParams(WINDOW.location.search).has('debug')){
    //   this.setData();
    // }

  }

  render() {
    const {
      containerId,
      containerClass,
      navigationTitle,
      navigationIcon,
      unsavedItemTabName,
      savedItemTabName,
      priceTitle,
      bodyColorTitle,
      seatColorTitle,
      makerOptionTitle,
      pcRecommendText,
      mbRecommendText,
      modelName,
      carId,
      carTypeCode,
      gradeId,
      estimateParam
    } = this.props;

    const est = this.getData();

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div className='EstimationHistory'>
          <div className='EstimationHistory__container'>
            {(() => {
              if(this.existEst('unsaved') || this.existEst('saved')){
                return (
                  <form className='EstimationHistory__container__estType' ref="estType" onChange={this.onChangeEstType}>
                    <ul className='EstimationHistory__container__estType__list'>
                      {(() => {
                        if(this.existEst('unsaved')){
                          return(
                            <li className="EstimationHistory__container__estType__list__item">
                              <label className={"EstimationHistory__container__estType__list__item__label" + (!this.existEst('saved') ? ' disabled' : '')}>
                                <input className="EstimationHistory__container__estType__list__item__label__radio" type="radio" name="estType" value='unsaved' checked={this.state.estType === 'unsaved'} onChange={this.onChangeEstType} />
                                <span className="EstimationHistory__container__estType__list__item__label__text">{unsavedItemTabName && unsavedItemTabName !== '' ? unsavedItemTabName : ''}</span>
                              </label>
                            </li>
                          )
                        }
                      })()}
                      {(() => {
                        if(this.existEst('saved')){
                          return(
                            <li className="EstimationHistory__container__estType__list__item">
                              <label className={"EstimationHistory__container__estType__list__item__label" + (!this.existEst('unsaved') ? ' disabled' : '')}>
                                <input className="EstimationHistory__container__estType__list__item__label__radio" type="radio" name="estType" value='saved' checked={this.state.estType === 'saved'} onChange={this.onChangeEstType} />
                                <span className="EstimationHistory__container__estType__list__item__label__text">{savedItemTabName && savedItemTabName !== '' ? savedItemTabName : ''}</span>
                              </label>
                            </li>
                          )
                        }
                      })()}
                    </ul>
                  </form>
                )
              }
            })()}
            {(() => {
              if(this.state.estExists === true){
                return (
                  <div
                    className='EstimationHistory__container__ests'
                    ref='ests'
                    onTransitionEnd={(e)=> {
                      e.currentTarget.classList.remove('fadein');
                      e.currentTarget.style.opacity = "";
                    }}
                  >
                    {(() => {
                      let sliders = [];
                      for(let estType in est) {
                        if(!Array.isArray(est[estType]) || est[estType].length === 0){
                          continue;
                        }
                        sliders.push(
                          <div
                            className={
                              'EstimationHistory__container__ests__slider' +
                              (estType === this.tmp.estType && this.tmp.estType !== '' ? ' show' : '')
                            }
                            key={estType}
                          >
                            <Slider
                              ref={'slider_' + estType}
                              settings={{
                                autoplay: false,
                                autoplaySpeed: 3000,
                                speed: 1000,
                                ease: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                                fade: false,
                                infinite: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                swipe: true,
                                draggable: false,
                                arrows: true,
                                dots: true,
                                adaptiveHeight: false,
                                centerMode: false,
                                centerPadding: 0,
                                waitForAnimate: false,
                                lazyLoad: 'progressive',
                                beforeChange: (old, current)=> {
                                  if(estType === 'unsaved'){
                                    this.tmp.unsavedIndex = current;
                                    this.setState({
                                      unsavedIndex: current
                                    });
                                  }
                                  else if(estType === 'saved'){
                                    this.tmp.savedIndex = current;
                                    this.setState({
                                      savedIndex: current
                                    });
                                  }
                                  //
                                  this.refs['slider_' + estType].beforeChange(old, current);
                                  this.onChangeEstSlide();
                                  //
                                  const moption = this.refs.moption;
                                  if(moption && moption.classList.contains('touch')){
                                    moption.classList.remove('showInfo');
                                  }
                                },
                                responsive: [
                                  {
                                    breakpoint: 767,
                                    settings: {
                                      arrows: false,
                                    }
                                  }
                                ]
                            }}>
                              {(() => {

                                // 100th Anniversary Special Edition > 100周年特別記念車
                                const convert100th = (text) => {
                                  if (text && text !== '') {
                                    text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
                                    text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
                                    text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
                                    text = text.replace('RF 35th SV', '35周年記念車');
                                    text = text.replace('35th SV', '35周年記念車');
                                    text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
                                    text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
                                    text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
                                    text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
                                    text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
                                    text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
                                    text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
                                    text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
                                    text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
                                    text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
                                    text = text.replace('15 SPORT Plus', '15 SPORT＋');
                                    text = text.replace('XD SPORT Plus', 'XD SPORT＋');
                                    return text;
                                  } else {
                                    return text;
                                  }
                                };

                                // 15S business use package > 15S＜ビジネスユースパッケージ付＞
                                const convertBusinessUsePackage = (text) => {
                                  if (text && text !== '') {
                                    return text.replace('15S business use package', '15S＜ビジネスユースパッケージ付＞');
                                  } else {
                                    return text;
                                  }
                                };

                                let estArr = est[estType];
                                if(Array.isArray(estArr) && estArr.length > 0){
                                  return(
                                    estArr.map((estData, index) => {
                                      let carImageSrc = estData.aic_s;
                                      // let carImageSrc = '/globalassets/assets/cars/' + this.format(this.convertCarIdToModelName(this.state.carInfo, estData.car_id)) + '/' + this.format(estData.car_id) + '/' + this.format(estData.car_type_code) + '/' + this.format(estData.grade_id) +  '/common/' + this.format(estData.grade_id) + '_' + estData.aic + '_s.png';
                                      // let carImageSrc = '/assets-dev/left.png';
                                      return(
                                        <div className='EstimationHistory__container__ests__slider__item' key={index}>
                                          <div className='EstimationHistory__container__ests__slider__item__name'>{this.convertCarIdToBodyTypeModel(this.state.carInfo, estData.car_id)}</div>
                                          <div className='EstimationHistory__container__ests__slider__item__title'>
                                            <span className='EstimationHistory__container__ests__slider__item__title__gradeId'>{convertBusinessUsePackage(convert100th(estData.grade_id))}</span>
                                            <span className='EstimationHistory__container__ests__slider__item__title__fuel'>{estData.fuel}</span>
                                            <span className='EstimationHistory__container__ests__slider__item__title__drive'>{estData.drive}</span>
                                            <span className='EstimationHistory__container__ests__slider__item__title__mission'>{estData.mission}</span>
                                          </div>
                                          <div className='EstimationHistory__container__ests__slider__item__image'>
                                            <img src={carImageSrc} className='EstimationHistory__container__ests__slider__item__image__img' />
                                          </div>
                                        </div>
                                      )
                                    })
                                  )
                                }
                              })()}
                            </Slider>
                          </div>
                        )
                      }
                      return(
                        <React.Fragment>
                        {sliders}
                        </React.Fragment>
                      )
                    })()}
                  </div>
                )
              }
              else{
                let carImageSrc = '/globalassets/assets/cars/' + this.format(modelName) + '/' + this.format(carId) + '/' + this.format(carTypeCode) + '/' + this.format(gradeId) + '/common/' + this.format(gradeId) + '_default_s.png';
                // let carImageSrc = '/assets-dev/atenza-sedan_gj7_default_s.png';
                let pcText = pcRecommendText && pcRecommendText !== '' ? pcRecommendText : '';
                let mbText = mbRecommendText && mbRecommendText !== '' ? mbRecommendText : (pcRecommendText && pcRecommendText !== '' ? pcRecommendText : '');

                return (
                  <div className='EstimationHistory__container__no-ests'>
                    <div className='EstimationHistory__container__no-ests__content'>
                      <div className='EstimationHistory__container__no-ests__content__image'>
                        <img src={carImageSrc} className='EstimationHistory__container__no-ests__content__image__img' />
                      </div>
                      <div className='EstimationHistory__container__no-ests__content__recommendText'>
                        {pcText && pcText !== '' ? <div className='EstimationHistory__container__no-ests__content__recommendText--pc' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(pcText)}}/> : null}
                        {mbText && mbText !== '' ? <div className='EstimationHistory__container__no-ests__content__recommendText--mb' dangerouslySetInnerHTML={{__html: convertPipeToBrTag(mbText)}}/> : null}
                      </div>
                      <div className='EstimationHistory__container__no-ests__content__button'>
                        <Cta
                          {...{
                            ctaType: 'Free',
                            text: 'カンタン見積り',
                            linkType: 'Button-With-Icon',
                            iconSrc: EstimateIconDark,
                            hoverIconSrc: EstimateIconLight,
                            color: 'Light',
                            buttonStyle: 'Action',
                            handleClick: this.onClickEstimate
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            })()}

            {(() => {
              const targetEst = this.getTargetEst();
              if(targetEst != null){
                const colorTipColor = targetEst.rgb ? '#' + targetEst.rgb : null;
                return (
                  <div
                    className='EstimationHistory__container__detail'
                    ref='detail'
                    onTransitionEnd={(e)=> {
                      e.currentTarget.classList.remove('fadein');
                      e.currentTarget.style.opacity = "";
                    }}
                  >
                    <div className='EstimationHistory__container__detail__prices'>
                      <div className='EstimationHistory__container__detail__prices__title'>PRICE</div>
                      <dl className='EstimationHistory__container__detail__prices__list'>
                        <dt className='EstimationHistory__container__detail__prices__list__title header'>
                          <span className='text'>{priceTitle && priceTitle !== '' ? priceTitle : ''}</span>
                        </dt>
                        <dd className='EstimationHistory__container__detail__prices__list__data header'>
                          <span className='text'>¥{Number(targetEst.estimated_amount).toLocaleString()}</span>
                          <span className='tax'>（消費税込）</span>
                        </dd>
                        <dt className='EstimationHistory__container__detail__prices__list__title'>車両本体価格</dt>
                        {(()=> {
                          if (targetEst.car_id === 'cx-8') {
                            if (
                              targetEst.grade_id === '25S Exclusive Mode' ||
                              targetEst.grade_id === 'XD Exclusive Mode'
                            ) {
                              if (targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ブラック）' || targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ピュアホワイト）') {
                                return (
                                  <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices + 165000).toLocaleString()}</dd>
                                )
                              }
                            }
                            if (targetEst.seat_color === '6人乗り レザー(レッド)' || targetEst.seat_color === '7人乗り レザー(レッド)') {
                              return (
                                <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices + 44000).toLocaleString()}</dd>
                              )
                            } else if (targetEst.seat_color === '6人乗り ナッパレザー(ピュアホワイト)' || targetEst.seat_color === '6人乗り ナッパレザー(オーバーン)') {
                              return (
                                <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices + 165000).toLocaleString()}</dd>
                              )
                            }
                          } else if (targetEst.car_id === 'cx-80') {
                            if (
                              targetEst.grade_id === 'XD Exclusive Mode' || // KL1
                              targetEst.grade_id === 'XD Drive Edition Nappa Leather Package' || // KL2
                              targetEst.grade_id === 'XD-HYBRID Exclusive Sports' // KL2
                            ) {
                              if (
                                targetEst.seat_color === '【6人乗り】キャプテンシート（ブラック・ナッパレザー）' || // KL1
                                targetEst.seat_color === '【6人乗り】キャプテンシート　シート材質（ナッパレザー）/シートカラー（ブラック）' // KL2
                              ) {
                                return (
                                  <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices + 143000).toLocaleString()}</dd>
                                )
                              }
                            }
                          }
                          return (
                            <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices).toLocaleString()}</dd>
                          )
                        })()}
                        {/*<dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.retail_prices).toLocaleString()}</dd>*/}
                        {(()=> {
                          /* カンタン見積もり特別処理 No166
                             car_id: mazda2, car_type_code: DJ5, grade_code: 10, moption_list: ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）
                             car_id: mazda2, car_type_code: DJ5, grade_code: 21, moption_list: ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）
                             上記条件の場合、メーカーセットオプション価格を非表示 (本体価格にMOPの価格が含まれているため)
                           */
                          if(targetEst.car_id === 'mazda2'){
                            if (targetEst.car_type_code === 'DJ5') {
                              if (targetEst.grade_code == 10 || targetEst.grade_code == 21) {
                                if (targetEst.moption_list === 'ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）') {
                                  return null;
                                }
                              }
                            } else if (targetEst.car_type_code === 'DJ6') {
                              if (targetEst.grade_code == 25) {
                                if (targetEst.moption_list === 'ルーフフィルム（ブラック）＋電動格納リモコン式カラードドアミラー（オート格納）（グロスブラック）') {
                                  return null;
                                }
                              }
                            }
                          }
                          return (
                            <React.Fragment>
                              <dt className='EstimationHistory__container__detail__prices__list__title special_no166'>メーカーセットオプション価格</dt>
                              <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.moption_prices).toLocaleString()}</dd>
                            </React.Fragment>
                          )
                        })()}
                        {/* <dt className='EstimationHistory__container__detail__prices__list__title'>メーカーセットオプション価格</dt>
                        <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.moption_prices).toLocaleString()}</dd> */}
                        <dt className='EstimationHistory__container__detail__prices__list__title'>ショップオプション価格</dt>
                        <dd className='EstimationHistory__container__detail__prices__list__data'>¥{Number(targetEst.soption_prices).toLocaleString()}</dd>
                        <dt className='EstimationHistory__container__detail__prices__list__title'>諸費用合計</dt>
                        <dd className='EstimationHistory__container__detail__prices__list__data'>{targetEst.total_expenses && !isNaN(targetEst.total_expenses) && targetEst.total_expenses > 0 ? '¥' + Number(targetEst.total_expenses).toLocaleString() : '-'}</dd>
                        {(() => {
                          if(!targetEst.total_expenses || isNaN(targetEst.total_expenses) || targetEst.total_expenses === 0){
                            return(
                              <div className='EstimationHistory__container__detail__prices__total-expenses-remarks'>※諸費用は見積結果画面でご確認ください。</div>
                            )
                          }
                        })()}
                        <dt className='EstimationHistory__container__detail__prices__list__title footer'>
                          <span className='text'>{priceTitle && priceTitle !== '' ? priceTitle : ''}</span>
                        </dt>
                        <dd className='EstimationHistory__container__detail__prices__list__data footer'>
                          <span className='text'>¥{Number(targetEst.estimated_amount).toLocaleString()}</span>
                          <span className='tax'>（消費税込）</span>
                        </dd>
                      </dl>
                      <div className='EstimationHistory__container__detail__prices__button'>
                        <Cta
                          {...{
                            ctaType: 'Free',
                            text: '見積りシミュレーション',
                            linkType: 'Button-With-Icon',
                            iconSrc: EstimateIconDark,
                            hoverIconSrc: EstimateIconLight,
                            color: 'Light',
                            buttonStyle: 'Action',
                            handleClick: this.onClickEstimateSimulate
                          }}
                        />
                      </div>
                    </div>
                    <div className='EstimationHistory__container__detail__colors'>
                      <dl className='EstimationHistory__container__detail__colors__list'>
                        {(() => {
                          if(targetEst.body_color && targetEst.body_color !== ''){
                            return (
                              <div className='EstimationHistory__container__detail__colors__list__group body-color'>
                                <dt className='EstimationHistory__container__detail__colors__list__title'>
                                  {bodyColorTitle && bodyColorTitle !== '' ? <span className='text'>{bodyColorTitle}</span> : null}
                                </dt>
                                <dd className='EstimationHistory__container__detail__colors__list__data'>
                                  {colorTipColor && colorTipColor !== '' ? <span className='colortip' style={{backgroundColor: colorTipColor }}></span> : null}
                                  <span className='text'>{targetEst.body_color}</span>
                                </dd>
                              </div>
                            )
                          }
                        })()}
                        {(() => {
                          if(targetEst.seat_color && targetEst.seat_color !== ''){
                            return (
                              <div className='EstimationHistory__container__detail__colors__list__group seat-color'>
                                <dt className='EstimationHistory__container__detail__colors__list__title'>
                                  {seatColorTitle && seatColorTitle !== '' ? <span className='text'>{seatColorTitle}</span> : null}
                                </dt>
                                <dd className='EstimationHistory__container__detail__colors__list__data'>
                                  {(()=> {
                                    if (targetEst.car_id === 'cx-8') {
                                      if (
                                        targetEst.grade_id === '25S Exclusive Mode' ||
                                        targetEst.grade_id === 'XD Exclusive Mode'
                                      ) {
                                        if (targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ブラック）' || targetEst.seat_color === '【6人乗り】キャプテンシート（ナッパレザー・ピュアホワイト）') {
                                          return (
                                            <span className='text'>{targetEst.seat_color + ' '}<span style={{display: 'inline-block'}}>+ ¥165,000</span></span>
                                          )
                                        }
                                      }
                                      if (targetEst.seat_color === '6人乗り レザー(レッド)' || targetEst.seat_color === '7人乗り レザー(レッド)') {
                                        return (
                                          <span className='text'>{targetEst.seat_color + ' '}<span style={{display: 'inline-block'}}>+ ¥44,000</span></span>
                                        )
                                      } else if (targetEst.seat_color === '6人乗り ナッパレザー(ピュアホワイト)' || targetEst.seat_color === '6人乗り ナッパレザー(オーバーン)') {
                                        return (
                                          <span className='text'>{targetEst.seat_color + ' '}<span style={{display: 'inline-block'}}>+ ¥165,000</span></span>
                                        )
                                      }
                                    } else if (targetEst.car_id === 'cx-80') {
                                      if (

                                        targetEst.grade_id === 'XD Exclusive Mode' || // KL1
                                        targetEst.grade_id === 'XD Drive Edition Nappa Leather Package' || // KL2
                                        targetEst.grade_id === 'XD-HYBRID Exclusive Sports'// KL2
                                      ) {
                                        if (
                                          targetEst.seat_color === '【6人乗り】キャプテンシート（ブラック・ナッパレザー）' || // KL1
                                          targetEst.seat_color === '【6人乗り】キャプテンシート　シート材質（ナッパレザー）/シートカラー（ブラック）'// KL2
                                        ) {
                                          return (
                                            <span className='text'>{targetEst.seat_color + ' '}<span style={{display: 'inline-block'}}>+ ¥143,000</span></span>
                                          )
                                        }
                                      }
                                    }
                                    return (
                                      <span className='text'>{targetEst.seat_color}</span>
                                    )
                                  })()}
                                </dd>
                              </div>
                            )
                          }
                        })()}
                      </dl>
                    </div>
                    {(() => {
                      if(targetEst.moption_list && targetEst.moption_list !== ''){
                        return (
                          <div className='EstimationHistory__container__detail__options'>
                            <dl className='EstimationHistory__container__detail__options__list'>
                              <dt className='EstimationHistory__container__detail__options__list__title'>{makerOptionTitle && makerOptionTitle !== '' ? makerOptionTitle : ''}</dt>
                              <dd className='EstimationHistory__container__detail__options__list__data'>
                                <div
                                  ref='moption'
                                  className={
                                    'EstimationHistory__container__detail__options__list__data__moption' +
                                    (targetEst.moption_explaininfo && targetEst.moption_explaininfo !== '' ? ' hasInfo' : '') +
                                    (WINDOW && WINDOW.ontouchstart === null  ? ' touch' : ' mouse')
                                  }
                                  onClick={this.onClickMoption}
                                  dangerouslySetInnerHTML={{__html: targetEst.moption_list}}
                                />
                                {targetEst.moption_explaininfo && targetEst.moption_explaininfo !== '' ? <div className='EstimationHistory__container__detail__options__list__data__explain' dangerouslySetInnerHTML={{__html: targetEst.moption_explaininfo}}/> : null}
                              </dd>
                            </dl>
                          </div>
                        )
                      }
                    })()}
                  </div>
                )
              }
            })()}
          </div>
        </div>
      </Wrapper>
    )
  }

  setData = () => {

    console.log('[debug]')

    let obj = {
      saved: [],
      unsaved: []
    };

    let sample = {
      id: [2.09154E+15],
      name: ['見積り2'],
      aic: ['25D'],
      aic_l: ['https://ssl.mazda.co.jp/purchase/estimate/img/demio/ext/1/25D_l.png'],
      aic_s: ['https://ssl.mazda.co.jp/purchase/estimate/img/demio/ext/1/25D_s.png'],
      car_name: ['デミオ'],
      grade_name: ['XD Mist Maroon(2WD 6AT)'],
      engine: ['SKYACTIV-D 1.5', 'SKYACTIV-G', 'SKYACTIV-X'],
      fuel: ['ディーゼル', 'ガソリン', 'ハイブリッド'],
      drive: ['6EC-AT', '6MT', '5MT', '電気式無段変速機'],
      mission: ['4WD', '2WD'],
      body_color: ['スノーフレイクホワイトパールマイカ'],
      seat_color: ['ディープレッド/ブラック（グランリュクス/クロス）'],
      estimated_amount: [2331743],
      retail_prices: [2095200],
      moption_prices: [32400],
      soption_prices: [76433],
      total_expenses: [127710],
      moption_list: ['CD/DVDプレーヤー＋地上デジタルTVチューナー（フルセグ）<br />あああああああああああああ'],
      moption_explaininfo: ['ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。ここにテキストが入る。'],
      grade_id: ['XD L Package'],
      car_id: ['atenza-sedan', 'atenza-wagon', 'axela-hybrid', 'axela-sport', 'axela-sedan', 'demio', 'cx-3', 'cx-5', 'cx-8', 'roadster', 'roadsterrf', 'flair', 'flair-wagon', 'flair-crossover', 'carol', 'scrum-wagon'],
      car_type_code: ['DE8', 'GJ7', 'GJ8'],
      grade_code: [1, 2, 3],
      ecode: ['W'],
      icode: ['W'],
      moption_select_list: [1E+11],
      soption_sel_index: [84],
      soptions: ['50:1:50:5000'],
      rgb: ['192a46'],
      model_name: ['demio'],
    };

    for(let i = 0; i < 6; i++){
      let data = {
        aic: sample.aic[Math.floor(Math.random()*sample.aic.length)],
        aic_s: sample.aic_s[Math.floor(Math.random()*sample.aic_s.length)],
        engine: sample.engine[Math.floor(Math.random()*sample.engine.length)],
        fuel: sample.fuel[Math.floor(Math.random()*sample.fuel.length)],
        drive: sample.drive[Math.floor(Math.random()*sample.drive.length)],
        mission: sample.mission[Math.floor(Math.random()*sample.mission.length)],
        body_color: sample.body_color[Math.floor(Math.random()*sample.body_color.length)],
        seat_color: sample.seat_color[Math.floor(Math.random()*sample.seat_color.length)],
        estimated_amount: Math.floor(Math.random()*9999999),
        retail_prices: Math.floor(Math.random()*9999999),
        moption_prices: Math.floor(Math.random()*9999999),
        soption_prices: Math.floor(Math.random()*9999999),
        total_expenses: Math.floor(Math.random()*9999999),
        moption_list: sample.moption_list[Math.floor(Math.random()*sample.moption_list.length)],
        moption_explaininfo: sample.moption_explaininfo[Math.floor(Math.random()*sample.moption_explaininfo.length)],
        grade_id: sample.grade_id[Math.floor(Math.random()*sample.grade_id.length)],
        car_id: sample.car_id[Math.floor(Math.random()*sample.car_id.length)],
        car_type_code: sample.car_type_code[Math.floor(Math.random()*sample.car_type_code.length)],
        grade_code: sample.grade_code[Math.floor(Math.random()*sample.grade_code.length)],
        ecode: sample.ecode[Math.floor(Math.random()*sample.ecode.length)],
        icode: sample.icode[Math.floor(Math.random()*sample.icode.length)],
        moption_select_list: sample.moption_select_list[Math.floor(Math.random()*sample.moption_select_list.length)],
        soption_sel_index: sample.soption_sel_index[Math.floor(Math.random()*sample.soption_sel_index.length)],
        soptions: sample.soptions[Math.floor(Math.random()*sample.soptions.length)],
        rgb: Math.floor(Math.random() * 16777215).toString(16),
        model_name: sample.model_name[Math.floor(Math.random()*sample.model_name.length)],
      };
      if(obj.saved.length < 3){
        obj.saved.push(data);
      }
      else{
        obj.unsaved.push(data);
      }
    }

    //test
    // delete　obj.saved;
    // delete　obj.unsaved;
    // obj.saved.pop();
    // obj.saved.pop();
    // obj.unsaved.pop();
    // obj.unsaved.pop();
    // obj.saved = [];
    // obj.unsaved = [];

    if(WINDOW && WINDOW.localStorage && WINDOW.localStorage.setItem){
      const json = JSON.stringify(obj);
      WINDOW.localStorage.removeItem('mj_est');
      WINDOW.localStorage.setItem('mj_est', json);
    }

  }

  getData = () => {
    let obj = {};

    if(!this.validEstimateJson()){
      return {};
    }

    if(WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem){
      const json = WINDOW.localStorage.getItem('mj_est');
      obj = JSON.parse(json);
    }
    return obj;
  }

  existEst = (estType) => {
    const est = this.getData();
    if(est && Object.keys(est).length > 0 && estType in est && Array.isArray(est[estType]) && est[estType].length > 0){
      return true;
    }
    return false;
  }

  onChangeEstType = (e) => {
    this.tmp.estType = e.target.value;
    this.setState({
      estType: e.target.value,
    });

    //fadein
    this.refs.ests.classList.remove('fadein');
    this.refs.detail.classList.remove('fadein');
    this.refs.ests.style.opacity = 0;
    this.refs.detail.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.ests.classList.add('fadein');
        this.refs.detail.classList.add('fadein');
        this.refs.ests.style.opacity = 1;
        this.refs.detail.style.opacity = 1;
      },
    10);
  }

  onChangeEstSlide = () => {
    //fadein
    this.refs.detail.classList.remove('fadein');
    this.refs.detail.style.opacity = 0;
    setTimeout(
      () => {
        this.refs.detail.classList.add('fadein');
        this.refs.detail.style.opacity = 1;
      },
    10);
  }

  convertCarIdToModelName = (carInfo, carId) => {

    let modelName;

    if(!carInfo || !Array.isArray(carInfo) || carInfo.length === 0 || !carId || carId === ''){
      return '';
    }

    for(let i = 0; i < carInfo.length; i++) {
      if('CarId' in carInfo[i] && 'ModelName' in carInfo[i] && carInfo[i].CarId === carId){
        modelName = carInfo[i].ModelName;
        return modelName;
      }
    }

    return '';
  };

  convertCarIdToBodyTypeModel = (carInfo, carId) => {

    let bodyTypeModel;

    if(!carInfo || !Array.isArray(carInfo) || carInfo.length === 0 || !carId || carId === ''){
      return '';
    }

    for(let i = 0; i < carInfo.length; i++) {
      if('CarId' in carInfo[i] && 'BodyTypeModel' in carInfo[i] && carInfo[i].CarId === carId){
        bodyTypeModel = carInfo[i].BodyTypeModel;
        return bodyTypeModel;
      }
    }

    return '';
  };

  getTargetEst = () => {
    const est = this.getData();
    const estType = this.tmp.estType && this.tmp.estType !== '' ? this.tmp.estType : '';
    let estIndex = null;
    let targetEst = null;

    if((this.existEst('unsaved') || this.existEst('saved')) && estType){
      estIndex = this.tmp[estType + 'Index'];
      targetEst = est[this.tmp.estType][estIndex];
    }

    return targetEst;
  }

  onClickEstimate = (e) => {
    const estimateParam = this.props.estimateParam;

    let query_car_id = this.getQuery('car_id');

    let cookie_car_id = this.getCookie('mjcarid');

    let car_id = query_car_id ? query_car_id : (cookie_car_id ? cookie_car_id : ( estimateParam && estimateParam !== '' ? estimateParam : null ));

    // let href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';

    // if(car_id != null){
    //   href += car_id !== '' ? ('edit.html?car_id=' + car_id) : '';
    // }

    let href = 'https://www.mazda.co.jp/purchase/estimate/';

    if(car_id != null){
      href += car_id !== '' ? ('?car_id=' + car_id) : '';
    }

    location.href = href;

    e.preventDefault();
  }

  onClickEstimateSimulate = (e) => {
    const est = this.getTargetEst();

    // let href = IS_MOBILE ? 'https://ssl.mazda.co.jp/sp/purchase/estimate/': 'https://ssl.mazda.co.jp/purchase/estimate/';

    // href += 'edit.html?' +
    //         'direct=id_contents_estimate&' +
    //         'car_id=' + (est.car_id != null ? est.car_id : '') + '&' +
    //         'car_type_code=' + (est.car_type_code != null ? est.car_type_code : '') + '&' +
    //         'drive=' + (est.drive != null ? est.drive : '') + '&' +
    //         'aic=' + (est.aic != null ? est.aic : '') + '&' +
    //         'icode=' + (est.icode != null ? est.icode : '') + '&' +
    //         'engine=' + (est.engine != null ? est.engine : '') + '&' +
    //         'grade_code=' + (est.grade_code != null ? est.grade_code : '') + '&' +
    //         'mission=' + (est.mission != null ? est.mission : '') + '&' +
    //         'moption_select_list=' + (est.moption_select_list != null ? est.moption_select_list : '') + '&' +
    //         'soption_sel_index=' + (est.soption_sel_index != null ? est.soption_sel_index : '') + '&' +
    //         'soptions=' + (est.soptions != null ? est.soptions : '');

    let href = 'https://www.mazda.co.jp/purchase/estimate/';

    href += '?' +
            'direct=id_contents_estimate&' +
            'car_id=' + (est.car_id != null ? est.car_id : '') + '&' +
            'car_type_code=' + (est.car_type_code != null ? est.car_type_code : '') + '&' +
            'drive=' + (est.drive != null ? est.drive : '') + '&' +
            'aic=' + (est.aic != null ? est.aic : '') + '&' +
            'icode=' + (est.icode != null ? est.icode : '') + '&' +
            'engine=' + (est.engine != null ? est.engine : '') + '&' +
            'grade_code=' + (est.grade_code != null ? est.grade_code : '') + '&' +
            'mission=' + (est.mission != null ? est.mission : '') + '&' +
            'moption_select_list=' + (est.moption_select_list != null ? est.moption_select_list : '') + '&' +
            'soption_sel_index=' + (est.soption_sel_index != null ? est.soption_sel_index : '') + '&' +
            'soptions=' + (est.soptions != null ? est.soptions : '');

    location.href = href;

    e.preventDefault();
  }

  onClickMoption = (e) => {
    const moption = this.refs.moption;
    if(moption && moption.classList.contains('touch')){
      moption.classList.toggle('showInfo');
    }
  }

  getQuery = (key) => {
    if(!WINDOW || !WINDOW.location){
      return false;
    }
    let params = WINDOW.location.search.substring(1).split('&');
    for(let i = 0; i < params.length; i++){
      let param = params[i].split('=');
      if(param[0].trim() === key){
        return param[1].trim();
      }
    }
    return false;
  };

  getCookie = (key) => {
    if(!DOCUMENT || !DOCUMENT.cookie){
      return false;
    }
    let cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++){
      let cookie = cookies[i].split('=');
      if(cookie[0].trim() === key){
        return cookie[1].trim();
      }
    }

    return false;
  };

  format = (str) => {
    return convertKataToRome(String(str).toLowerCase().split(' ').join('-'));
  };

  validEstimateJson = () => {
    if (WINDOW && WINDOW.localStorage && WINDOW.localStorage.getItem) {
      const json = WINDOW.localStorage.getItem('mj_est');
      try{
        JSON.parse(json);
        return true;
      }
      catch (e) {
        return false;
      }
    }
    else{
      return false;
    }
  };

}

export default EstimationHistory;



// WEBPACK FOOTER //
// ./src/containers/estimation-history/index.jsx